<template>
    <div class="index">
        <Header @show-contact="showContact" :active="0"></Header>
        <!-- 导航栏 -->
        <div class="banner">
            <img class="banner-pc" src="../assets/image/banner/banner_index.png" alt="荟镜XR 慧建智联"></img>
            <img class="banner-m" src="../assets/image/banner/banner_index_m.jpg" alt="荟镜XR 慧建智联"></img>
        </div>
        <!-- 公司简介 -->
        <div class="container-index" id="container">
            <img src="../assets/image/index/compony.jpg" alt="荟镜XR 慧建智联">
            <h1 class="container-title" alt="荟镜XR 慧建智联">关于慧建智联</h1>
            <div class="content">
                <p>杭州慧建智联科技有限公司</p>
                <span style="margin-top: -0.4rem;">Hangzhou Huijian Smartlink Co., Ltd</span><br></br>
                <img src="../assets/image/icon/icon_firm.png" alt="荟镜XR 慧建智联">
                <span>
                    杭州慧建智联科技有限公司成立于2021年，总部位于北京，已在北京、杭州、成都、苏州、青岛构建 "三大研发中心 + 三大业务运营中心" 的全国战略布局。慧建智联深耕人工智能（AI）与拓展现实（XR）技术研发，深度融合人工智能、智能传感器、脑机接口、物联网、空间智能、边缘计算等前沿技术，致力于成为国际领先的AIXR空间智能科技公司。自主研发的全国产化【荟镜XR头显】系列智能硬件在工业级已达到全球行业顶尖水平。
                </span>
            </div>
        </div>
        <h2 class="title-m">关于慧建智联</h2>
        <div class="info-m" id="team">
            <div class="top">
                <p>
                    <img src="../assets/image/icon/icon_firms_m.png" align="left" alt="荟镜XR 慧建智联">
                    杭州慧建智联科技有限公司成立于2021年，总部位于北京，已在北京、杭州、成都、苏州、青岛构建 "三大研发中心 + 三大业务运营中心" 的全国战略布局。慧建智联深耕人工智能（AI）与拓展现实（XR）技术研发，深度融合人工智能、智能传感器、脑机接口、物联网、空间智能、边缘计算等前沿技术，致力于成为国际领先的AIXR空间智能科技公司。自主研发的全国产化【荟镜XR头显】系列智能硬件在工业级已达到全球行业顶尖水平。
                </p>
            </div>
        </div>
        <!-- 产品介绍 -->
        <div class="product-index" id="product">
            <p class="product-title">产品介绍</p>
            <div class="product-xr">
                <!-- <div class="product-xr-left">
                    <p class="product-xr-text">XR1定焦安全版 混合现实头戴显示设备</p>
                    <p>· 高PPD</p>
                    <p>· 低延时</p>
                    <p>· 大视场角</p>
                    <a class="product-xr-button" href="/products/XR1">了解更多</a>
                </div> -->
                <div class="product-xr-right">
                    <p class="product-xr-text">XR2定焦安全版 混合现实头戴显示设备</p>
                    <p>· 高分辨率</p>
                    <p>· 低时延</p>
                    <p>· 全国产自主可控</p>
                    <a class="product-xr-button" href="/#/products/XR2">了解更多</a>
                </div>
            </div>
            <div class="product-vr">   
                <div class="product-vr-right">
                    <p class="product-vr-text">VR2卓越安全版 虚拟现实头戴显示设备</p>
                    <p>· 高分辨率</p>
                    <p>· 大视场角</p>
                    <p>· 全国产自主可控</p>
                    <a class="product-vr-button" href="/#/products/VR2">了解更多</a>
                </div>
            </div>
        </div>
        <div class="product-m">
            <p class="product-title">产品介绍</p>
            <a href="/products/XR1"><img src="../assets/image/index/product-xr1-m.jpg" alt="荟镜XR 慧建智联"></a>
            <a href="/#/products/XR2"><img src="../assets/image/index/product-xr2-m.jpg" alt="荟镜XR 慧建智联"></a>
            <a href="/#/products/VR1"><img src="../assets/image/index/product-vr1-m.jpg" alt="荟镜XR 慧建智联"></a>
            <a href="/#/products/VR2"><img src="../assets/image/index/product-vr2-m.jpg" alt="荟镜XR 慧建智联"></a>
        </div>
        <!-- 解决方案 -->
        <div class="solution-index" id="solution">
            <p class="solution-title">解决方案</p>
            <div class="solution-detail">
                <div class="item-index">
                    <a href="/#/solutions/aviation" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-aviation.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">飞行</h2>
                        <img class="item-img" src="../assets/image/icon/icon_arrow.png" alt="荟镜XR 慧建智联">
                    </a>
                </div>
                <div class="item-index">
                    <a href="/#/solutions/training" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-training.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">军体</h2>
                        <img class="item-img" src="../assets/image/icon/icon_arrow.png" alt="荟镜XR 慧建智联">
                    </a>
                </div>
                <div class="item-index">
                    <a href="/#/solutions/industry" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-building.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">工业</h2>
                        <img class="item-img" src="../assets/image/icon/icon_arrow.png" alt="荟镜XR 慧建智联">
                    </a>
                </div>
                <div class="item-index">
                    <a href="/#/solutions/lowAltitude" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-aviation.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">低空</h2>
                        <img class="item-img" src="../assets/image/icon/icon_arrow.png" alt="荟镜XR 慧建智联">
                    </a>
                </div>
            </div>
            <div class="solution-detail-m">
                <div class="item-m">
                    <a href="/#/solutions/aviation" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-aviation.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">飞行</h2>
                    </a>
                </div>
                <div class="item-m">
                    <a href="/#/solutions/training" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-training.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">军体</h2>
                    </a>
                </div>
                <div class="item-m">
                    <a href="/#/solutions/industry" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-building.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">工业</h2>
                    </a>
                </div>
                <div class="item-m">
                    <a href="/#/solutions/lowAltitude" class="item-link">
                        <img class="bg" src="../assets/image/index/solution-aviation.jpg" alt="荟镜XR 慧建智联">
                        <h2 class="title">低空</h2>
                    </a>
                </div>
            </div>
        </div>
        <!-- 合作方案 -->
        <!-- <div class="partner-index" id="partner">
            <p class="partner-title">合作伙伴</p>
            <img class="partner-pc" src="../assets/image/index/partner-pc.jpg">
            <img class="partner-m" src="../assets/image/index/partner-m.jpg">
        </div> -->
        <Footer></Footer>
        <Contact v-if="isContactVisible" @close="close"></Contact>
        <Email @show-contact="showContact"></Email>
    </div>
</template>

<script>
import { baseUrl } from '../api/images';
import { uploadeImage } from '../api/images'
import Footer from '../components/Footer.vue'
import Header from '../components/Head.vue'
import Contact from '../components/Contact.vue'
import Email from '../components/Email.vue'
export default {
    data() {
        return {
            uploadeImage: uploadeImage,
            isFixed: false,
            logo: baseUrl + 'logo.png',
            menu: baseUrl + 'menu.png',
            isContactVisible: false
        };
    },
    components: {
        Footer,
        Header,
        Contact,
        Email
    },
    methods: {
        goAbout() {
            this.$router.push({ name: 'About' });
        },
        goProduct() {
            this.$router.push({ name: 'Product' });
        },
        goToJump(num) {
            switch (num) {
                case 1:
                    window.location.href = '/#/products/XR1';
                    break;
                case 2:
                    window.location.href = '/#/products/XR2'
                    break;
                case 3:
                    window.location.href = '/#/products/VR1'
                    break;
                case 4:
                    window.location.href = '/#/products/VR2'
                    break;
            }
        },
        showContact() {
            this.isContactVisible = true
        },
        close() {
            this.isContactVisible = false;
        },
        goToSolution(num) {
            switch (num) {
                case 1:
                    window.location.href = '/#/solutions/aviation';
                    break;
                case 2:
                    window.location.href = '/#/solutions/training'
                    break;
                case 3:
                    window.location.href = '/#/solutions/industry'
                    break;
                case 4:
                    window.location.href = '/#/solutions/lowAltitude'
                    break;
            }
        }
        
    },
};
</script>

<style scoped>
    @import '../assets/css/indexStyle.css';
</style>